import { GET_DIVISIONS } from "constants/divisions";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_DIVISIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
